/** Default negotiated RTCDataChannel name used when no custom name is provided. */
export const DEFAULT_CHANNEL_NAME = 'MessengerRTCChannelDefault';
